"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreRawItemClass = void 0;
var constants_1 = require("../../../constants");
var ScoreRawItemClass = /** @class */ (function () {
    function ScoreRawItemClass(scoreRawItem) {
        if (scoreRawItem === void 0) { scoreRawItem = {}; }
        Object.assign(this, scoreRawItem);
    }
    Object.defineProperty(ScoreRawItemClass.prototype, "isBranch", {
        get: function () {
            return this.itemType === constants_1.ItemType.Branch;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScoreRawItemClass.prototype, "isCore", {
        get: function () {
            return this.itemType === constants_1.ItemType.Core;
        },
        enumerable: false,
        configurable: true
    });
    return ScoreRawItemClass;
}());
exports.ScoreRawItemClass = ScoreRawItemClass;
